import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    ui: {
        readmoreToggle:      ".truncated",
    }
})

export default class ReadMore extends Marionette.View<Backbone.Model>{

    onRender() {
        if (!this.ui.readmoreToggle.length) {
            return;
        }

        const button = $('<button class="btn btn--full">Read More</button>');

        button.on('click', () => {
            this.ui.readmoreToggle.addClass('is-visible');
            button.hide();
        })

        this.ui.readmoreToggle.after(button);
    }
}



// WEBPACK FOOTER //
// ./@modules/views/read-more.ts